import { FilterMatchMode } from 'primereact/api';
import { SearchMode } from '../../../types/general-types';
import { ColumnDefinitions } from '../columnFactory/types';

/**
 * Simple function to generate DEFAULT_FILTERS from existing ColumnDefinitions
 * Maps column types to their appropriate filter configurations
 */
export const generateFiltersFromColumns = (columnDefinitions: ColumnDefinitions) => {
  const filters = {};

  Object.entries(columnDefinitions).forEach(([fieldName, columnConfig]) => {
    // Skip if not filterable
    if (columnConfig.filterable === false) {
      return;
    }

    // Generate filter based on column type
    switch (columnConfig.type) {
      case 'string':
        filters[fieldName] = {
          value: '',
          searchMode: SearchMode.CONTAINS,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;

      case 'bool':
        filters[fieldName] = {
          value: null,
          searchMode: SearchMode.EQUALS,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;

      case 'number':
      case 'int':
      case 'date':
        filters[fieldName] = {
          value: [],
          searchMode: SearchMode.BETWEEN,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;

      case 'enum':
        filters[fieldName] = {
          value: null,
          searchMode: SearchMode.IN,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;

      case 'multiEnum':
      case 'multiReference':
        filters[fieldName] = {
          value: null,
          searchMode: SearchMode.OVERLAPS,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;

      default:
        // Default to string-like behavior
        filters[fieldName] = {
          value: '',
          searchMode: SearchMode.CONTAINS,
          matchMode: FilterMatchMode.CUSTOM,
        };
        break;
    }
  });

  return filters;
};
